module.exports = __webpack_public_path__ + "img/person_feedback_success.5fc24c80.png";